import {
  IConfiguration,
  IConfigurationService,
} from "../../domain/configuration";
import store from "../../store";
import { SessionStorageAccessor } from "../../store/SessionStorageAccessor";
import { ConfigurationRepository } from "./ConfigurationRepository";
import { LoggerFactory } from "../../utilities/logger";

export class ConfigurationService implements IConfigurationService {
  constructor(private readonly _repository: ConfigurationRepository) {
  }

  private readonly logger = LoggerFactory.getLogger();

  async load(): Promise<void> {
    store.commit("setConfiguration", await this.loadConfiguration());
  }

  getConfiguration(): IConfiguration {
    return store.getters.configuration as IConfiguration;
  }

  private async loadConfiguration(): Promise<IConfiguration> {
    if (store.getters.configuration) {
      this.logger.info("既にstoreに格納されてる設定を利用します.");
      return store.getters.configuration;
    } else if (SessionStorageAccessor.configuration) {
      this.logger.info("セッションストレージに格納されてる設定を利用します.");
      return SessionStorageAccessor.configuration as IConfiguration;
    } else {
      this.logger.info("バックエンドから設定を取得します.");
      return this._repository.getConfiguration();
    }
  }
}
